






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { routes } from '@/static/routes';
import { LinkButton } from '@/components/Base';
import { getZendeskAuthURL, KEYCLOAK_LOGOUT_URL } from '@/constants/urls';
import MySenseflyLogo from '@/assets/images/mysensefly-logo.svg';
import { getValidToken } from '@/components/auth/token';

@Component({
  components: {
    LinkButton,
    MySenseflyLogo,
  },
})
export default class Navbar extends Vue {
  @Prop() public items: string[];
  public routes = routes;
  public KEYCLOAK_LOGOUT_URL = KEYCLOAK_LOGOUT_URL;

  public async openZendesk() {
    const token = await getValidToken();
    const authURL = getZendeskAuthURL(token);
    window.open(authURL, '_blank');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/Navbar/Navbar.vue